import CodeInput from "@/shared/ui/codeInput/CodeInput";

type Props = {
  value: string;
  onChange?: (value: string) => void;
  codeLength: number;
  pending?: boolean;
  isValid?: boolean;
};

export default function AuthCodeInput({
  value,
  onChange,
  pending,
  codeLength,
  isValid = true,
}: Props) {
  return (
    <div inert={pending ? "" : null}>
      <CodeInput
        name="code"
        type="number"
        inputMode="latin"
        fields={codeLength}
        value={value}
        onChange={onChange}
        inputStyle={{ display: "block" }}
        className={pending ? "opacity-80" : ""}
        isValid={isValid}
      />
    </div>
  );
}
